import * as Yup from "yup";

export const SecondStepSchema = Yup.object({
  nombre: Yup.string()
    .required("El campo Nombre es requerido")
    .min(2, "El campo Nombre debe tener mínimo 2 caracteres")
    .max(50, "El campo Nombre puede tener hasta 50 caracteres"),
  apellido: Yup.string()
    .required("El campo Apellido es requerido")
    .min(2, "El campo Apellido debe tener mínimo 2 caracteres")
    .max(50, "El campo Apellido puede tener hasta 50 caracteres"),
  dni: Yup.number("El campo DNI debe ser numérico").required(
    "El campo DNI es requerido"
  ),
  provincia: Yup.string().required("El campo Provincia es requerido"),
  telefono: Yup.string()
    .test("is-number", "El campo teléfono debe ser numérico", (value) => {
      if (!value) return true;
      return /^\d+$/.test(value); // Verifica que el valor contenga solo números
    })
    .required("El campo teléfono es obligatorio"),
  especialidad: Yup.string()
    .required("El campo especialidad es obligatorio")
    .max(45, "El campo Especialidad no puede tener más de 45 caracteres"),
  nacimiento: Yup.date()
    .required("El campo Fecha de nacimiento es obligatorio")
    .test(
      "is-before-today",
      "La fecha de nacimiento debe ser anterior al día de hoy",
      (value) => {
        const selectedDate = new Date(value);
        const today = new Date();
        return selectedDate < today;
      }
    ),
  sexo: Yup.string()
    .notOneOf([""], "Por favor, selecciona una opción")
    .required("El campo Sexo es requerido")
    .test(
      "notEmpty",
      "Por favor, selecciona una opción",
      (value) => value && value.trim() !== ""
    ),

  direccion: Yup.string()
    .required("El campo Dirección es obligatorio")
    .max(500, "El cmapo Dirección no puede tener más de 500 caracteres"),
  email: Yup.string()
    .required("El campo Email es requerido")
    .email("El formato del campo Email es incorrecto")
    .max(100, "El campo Email puede tener hasta 100 caracteres"),
  password: Yup.string()
    .required("El campo contraseña es requerido")
    .min(10, "La contraseña debe tener al menos 8 caracteres")
    .max(20, "La contraseña no debe exceder los 20 caracteres")
    .test(
      "lowercase-test",
      "La contraseña debe contener al menos 2 letras minúsculas",
      value => /(?=(.*[a-zñüáéíóú]){2,})/.test(value)
    )
    .test(
      "uppercase-test",
      "La contraseña debe contener al menos 2 letras mayúsculas",
      value => /(?=(.*[A-ZÑÜÁÉÍÓÚ]){2,})/.test(value)
    )
    .test(
      "number-test",
      "La contraseña debe contener al menos 2 números",
      value => /(?=(.*\d){2,})/.test(value)
    )
    .test(
      "special-character-test",
      "La contraseña debe contener al menos 2 caracteres especiales",
      value => /(?=(.*[@$!%*?&'`.]){2,})/.test(value)
    ),
  repassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Las contraseñas deben coincidir")
    .required("Confirme su contraseña"),
  terminosCondiciones: Yup.boolean()
    .oneOf([true], "Debe aceptar los términos y condiciones")
    .required("Debe aceptar los términos y condiciones"),
});
